import { Component, Inject } from '@angular/core';
import { SnackbarDataInterface } from './snackbar-data-interface';
import { ApiError } from '../error/api-error';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from "@ngx-translate/core";
import { NgForOf, NgIf } from "@angular/common";
import { SnackbarData } from "./snackbar-data";

@Component({
  selector: 'app-snackbar-message',
  templateUrl: './snack-bar-message.component.html',
  styles: [`
    .message-detail {
      font-size: 11px;
      font-style: italic;
    }

    .message-errors {
      list-style: none;
      padding: 0;
      margin: 10px 0 0 0;
    }

    .message-errors li {
      font-size: 11px;
    }
  `],
  imports: [
    TranslateModule,
    NgIf,
    NgForOf
  ],
  standalone: true
})
export class SnackBarMessageComponent {
    public title = 'Error_unknown';
    public detail: string | null = null;
    public errors: any[] = [];
    public statusCode = 500;
    public type = '';

    constructor(
        public snackBarRef: MatSnackBarRef<SnackBarMessageComponent>,
        @Inject(MAT_SNACK_BAR_DATA) snackbackData: any
    ) {
        snackbackData = new SnackbarData(snackbackData.message, snackbackData.error);

        this.title = snackbackData.getMessage();

        if (snackbackData.getError()) {
          const error = snackbackData.getError() as ApiError;
          this.type = error?.type;
          this.title = this.title || error?.title;
          this.detail = error?.detail;
          this.statusCode = error?.status;
          this.errors = Object.keys(error?.errors).map((k: any) => error?.errors[k]);
        }
    }

    public hasErrors(): boolean {
        return this.errors && this.errors.length > 0;
    }
}
